export const state = {
  lang: window.localStorage.getItem('tumar_lang') ?? navigator.language.split('-')[0],
  locales: []
}
